import React from "react";
import MainAutoBuy from "../../../Component/Products/AutoBuy";

const AutoBuy = () => <MainAutoBuy />;

export default AutoBuy;
